import { render, staticRenderFns } from "./BidPauseStatusColumnContent.vue?vue&type=template&id=5f2e3d7c"
import script from "./BidPauseStatusColumnContent.vue?vue&type=script&lang=js"
export * from "./BidPauseStatusColumnContent.vue?vue&type=script&lang=js"
import style0 from "./BidPauseStatusColumnContent.vue?vue&type=style&index=0&id=5f2e3d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports